import { Group } from "@mantine/core";
import { APIKeySelector, type APIKeySelectorProps } from "../components/APIKeySelector.js";
import { DateRangeSelector, type DateRangeSelectorProps } from "./components/DateRangeSelector.js";
import { TimeIntervalSelector, type TimeIntervalSelectorProps } from "./components/TimeIntervalSelector.js";
import { DetailedViewSelector, type DetailedViewSelectorProps } from "./components/DetailedViewSelector.js";
import { TieredPriceProductId, type ProductId } from "@project/common";

const apiKeyConsumers: ProductId[] = [
  TieredPriceProductId.TieredTileUsage,
  TieredPriceProductId.TieredMapSession,
  TieredPriceProductId.TieredProcessing,
];

export type UsageControlsProps =
  APIKeySelectorProps &
  DateRangeSelectorProps &
  TimeIntervalSelectorProps &
  DetailedViewSelectorProps;

export const UsageControls = ({
  apiKeys,
  apiKeyId,
  dateRange,
  setApiKeyId,
  setDateRange,
  timeInterval,
  setTimeInterval,
  metricsInDetailedView,
  addToDetailedView,
  removeFromDetailedView,
  clearDetailedView,
}: UsageControlsProps) => (
  <Group>
    <DateRangeSelector {...{ dateRange, setDateRange }} />
    <TimeIntervalSelector {...{ timeInterval, setTimeInterval }} />
    <DetailedViewSelector
      {...{
        metricsInDetailedView,
        addToDetailedView,
        removeFromDetailedView,
        clearDetailedView,
      }}
    />
    {metricsInDetailedView.some(metric => apiKeyConsumers.includes(metric))
      && <APIKeySelector {...{ apiKeys, apiKeyId, setApiKeyId }} />}
  </Group>
);
